<template>
  <v-row class="caption font-weight-bold" :class="textColor" justify="center" align="center" style="height: 100%">
    <div class="d-flex align-center" style="position: absolute; left: -5px; top: 5px">
      <CommissionReceivedDialog
        :external="external"
        :bookingId="bookingId"
        :bookingSupplierId="bookingSupplierId"
        :supplierId="supplierId"
        :commission="commission"
        :commissionTotal="commissionTotal"
        :customCommissionAmount="customCommissionAmount"
        :commissionReceivedHistory="commissionReceivedHistory"
        :commissionPaid="commissionPaid"
        @toggle-commission-received="$emit('toggle-commission-received')"
        @add-row="(v) => $emit('add-commission-history', v)"
      />
    </div>

    <CommissionDisplay
      :commission="commission"
      :commissionTotal="displayCommissionTotal"
      :customCommissionAmount="customCommissionAmount"
      :commissionPaid="commissionPaid"
    />

    <div class="d-flex align-center" style="position: absolute; right: -5px; top: 5px">
      <CommissionCustomDialog
        :external="external"
        :bookingId="bookingId"
        :supplierId="supplierId"
        :supplierName="supplierName"
        :customCommissionId="customCommissionId"
        :customCommission="customCommissionAmount"
        :compiledCommissionTotal="commissionTotal"
        @sync-commission="(v) => $emit('sync-commission', v)"
      />
    </div>
  </v-row>
</template>

<script>
import money from "@/services/money";
import CommissionReceivedDialog from "./commissions/CommissionReceivedDialog";
import CommissionCustomDialog from "./commissions/CommissionCustomDialog";
import CommissionDisplay from "./commissions/CommissionDisplay";
export default {
  props: {
    external: Boolean,
    bookingId: String,
    bookingSupplierId: String,
    supplierId: String,
    supplierName: String,
    typeAs: String,
    // Commission
    commission: [Number, Boolean],
    commissionTotal: String,
    commissionReceivedHistory: Array,
    commissionPaid: Boolean,
    customCommissionList: Array,
  },
  components: {
    CommissionCustomDialog,
    CommissionReceivedDialog,
    CommissionDisplay,
  },
  computed: {
    customCommission() {
      let num = (this.customCommissionList || []).find(
        (item) => item.supplier_id === this.supplierId && item.type_as === this.typeAs
      );
      return num ? num : {};
    },
    customCommissionId() {
      return this.customCommission.id || null;
    },
    customCommissionAmount() {
      return this.customCommission.custom_amount || null;
    },
    displayCommissionTotal() {
      if (this.commissionPaid && !this.receivedCommissionTotal) return this.commissionTotal;
      if (this.commissionPaid) return this.formatCost(this.receivedCommissionTotal);
      return this.commissionTotal;
    },
    receivedCommissionTotal() {
      const history = this.commissionReceivedHistory ?? [];
      return history.reduce((sum, item) => sum + money.stripFormatting(item.total_received), 0);
    },
    hasCommissionReceivedHistory() {
      return (this.commissionReceivedHistory || []).length > 0;
    },
    textColor() {
      const fullCommissionReceived = (this.commissionReceivedHistory || []).find((v) => v.received_type === "FULL");
      const onlyPartReceived = (this.commissionReceivedHistory || []).find((v) => v.received_type === "PARTIAL");
      if (this.commissionPaid && !this.hasCommissionReceivedHistory) return "blue--text";
      if (this.commissionPaid) return "green--text";
      if (fullCommissionReceived) return "blue--text";
      if (onlyPartReceived) return "orange--text";
      return "";
    },
  },
  methods: {
    formatCost(value) {
      return value ? `$ ${money.format(value, { precision: 2 })}` : "$ --";
    },
  },
};
</script>
